import { queryOptions } from '@tanstack/react-query';
import { summaryQueryRoot } from '../../../../shared/api/index.js';
import type { MonthInsight } from '../../model/month-insight.js';
import type { YearSummary } from '../../model/year-summary.js';
import { getCalendar } from '../requests/get-calendar.js';
import { getMonthInsight } from '../requests/get-month-insight.js';
import { getSummary } from '../requests/get-summary.js';

/** The key of a request without a year: the server picks the year, so the cache names it as such. */
const CURRENT_YEAR = 'current';

const EVERY_CATEGORY = 'every';

const EVERY_MONTH = 'every';

const HISTORY_REFRESH_MS = 60_000;

const isHistoryLoading = (summary: YearSummary | undefined): boolean =>
  summary?.bank?.isHistoryComplete === false;

const isInsightWaitingForHistory = (insight: MonthInsight | undefined): boolean =>
  insight?.isHistoryComplete === false;

export const summaryQueries = {
  ...summaryQueryRoot,
  year: (year: number | null = null, month: number | null = null, category: string | null = null) =>
    queryOptions({
      queryKey: [
        ...summaryQueryRoot.all(),
        'year',
        year ?? CURRENT_YEAR,
        month ?? EVERY_MONTH,
        category ?? EVERY_CATEGORY,
      ] as const,
      queryFn: ({ signal }) => getSummary({ year, month, category }, signal),
      refetchInterval: (query) => (isHistoryLoading(query.state.data) ? HISTORY_REFRESH_MS : false),
    }),
  calendar: (year: number | null = null) =>
    queryOptions({
      queryKey: [...summaryQueryRoot.all(), 'calendar', year ?? CURRENT_YEAR] as const,
      queryFn: ({ signal }) => getCalendar(year, signal),
    }),
  insight: () =>
    queryOptions({
      queryKey: [...summaryQueryRoot.all(), 'insight'] as const,
      queryFn: ({ signal }) => getMonthInsight(signal),
      refetchInterval: (query) =>
        isInsightWaitingForHistory(query.state.data) ? HISTORY_REFRESH_MS : false,
    }),
};
